import React from 'react';
import { ecx } from "../../../core/utils.mjs";
export var DisabledOverlay = function DisabledOverlay() {
  return /*#__PURE__*/React.createElement("div", {
    className: ecx(['mega-selector__disabled-overlay'])
  });
};